import {GetOurDoctorMessageParams} from 'domain/usecases/private/home/get-our-doctor-message';
import {makeGetOurDoctorMessage} from 'main/factories/usecases/private/remote-home/get-our-doctor-message';

export const getOurDoctorMessage = async (params: GetOurDoctorMessageParams) => {
	const response = await makeGetOurDoctorMessage().get(params);
	return response;
};
